import React from 'react';
import {
  Paper, Box, Typography, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, TextField, MenuItem,
} from '@mui/material';
import { VMRow, BACKUP_OPTIONS, DR_TESTING_OPTIONS } from './types';

interface VMConfigSectionProps {
  vms: VMRow[];
  onUpdateVM: (id: number, field: string, value: unknown) => void;
}

const VMConfigSection: React.FC<VMConfigSectionProps> = ({ vms, onUpdateVM }) => {
  if (vms.length === 0) return null;

  return (
    <Paper sx={{ mb: 3, elevation: 2, border: 1, borderColor: 'grey.300' }}>
      <Box sx={{ p: 1, backgroundColor: 'grey.300', borderBottom: 1, borderColor: 'divider' }}>
        <Typography variant="h6" sx={{ fontSize: '1rem', fontWeight: 600 }}>VM Configuration</Typography>
      </Box>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontSize: '0.75rem', fontWeight: 700, textTransform: 'uppercase', color: 'text.secondary', py: 0.375, px: 0.25 }}>VM</TableCell>
              <TableCell sx={{ fontSize: '0.75rem', fontWeight: 700, textTransform: 'uppercase', color: 'text.secondary', py: 0.375, px: 0.25, textAlign: 'center' }}>Daily Backups</TableCell>
              <TableCell sx={{ fontSize: '0.75rem', fontWeight: 700, textTransform: 'uppercase', color: 'text.secondary', py: 0.375, px: 0.25, textAlign: 'center' }}>Enhanced DR (tests/year)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {vms.map((vm) => (
              <TableRow key={vm.id} hover>
                <TableCell sx={{ py: 0.375, px: 0.25, verticalAlign: 'middle' }}>
                  <Typography variant="body2" fontWeight={600}>{vm.name || 'Virtual Machine'}</Typography>
                </TableCell>
                <TableCell sx={{ py: 0.375, px: 0.25, verticalAlign: 'middle', textAlign: 'center' }}>
                  <TextField select size="small" value={vm.dailyBackups ?? 0}
                    onChange={(e) => onUpdateVM(vm.id, 'dailyBackups', parseInt(e.target.value, 10))} sx={{ width: 80 }}>
                    {BACKUP_OPTIONS.map((opt) => <MenuItem key={`cfgbk-${vm.id}-${opt.value}`} value={opt.value}>{opt.label}</MenuItem>)}
                  </TextField>
                </TableCell>
                <TableCell sx={{ py: 0.375, px: 0.25, verticalAlign: 'middle', textAlign: 'center' }}>
                  <TextField select size="small" value={vm.drTestingFrequency ?? 0}
                    onChange={(e) => onUpdateVM(vm.id, 'drTestingFrequency', parseInt(e.target.value, 10))} sx={{ width: 80 }}>
                    {DR_TESTING_OPTIONS.map((opt) => <MenuItem key={`cfdr-${vm.id}-${opt.value}`} value={opt.value}>{opt.label}</MenuItem>)}
                  </TextField>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default VMConfigSection;
